exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#loading{background:rgba(255,255,255,.6);position:fixed;height:100vh;width:100vw;z-index:10010;top:0;left:0;text-align:center\n}\n#loading i{Position:absolute;Top:50%;Transform:translateY(-50%)\n}\n.top-right{position:absolute;top:5px;right:30px;z-index:2;background:rgba(255,255,255,.7);border-radius:50%;padding:5px\n}\n@media only screen and (min-device-width: 320px)and (max-device-width: 667px){\n.top-right{right:5px\n}\n}\n.testimonial-card-edit{min-height:100px\n}\n.approved{color:green\n}\n.unapproved{color:#000\n}\n.center-block{display:block;margin:1rem auto;text-align:center\n}", ""]);

// exports
